import { Component, Inject, ViewEncapsulation, ViewChild, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';
import { Navigation, Pagination } from 'swiper/modules';
import { ResourceUrlInterface } from '@interfaces/components/resource-url.interface';
Swiper.use([Navigation, Pagination]);

@Component({
  selector: 'app-media-gallery',
  templateUrl: './resource-gallery.component.html',
  styleUrls: ['./resource-gallery.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  encapsulation: ViewEncapsulation.None,
})
export class ResourceGalleryComponent implements AfterViewInit, OnDestroy {
  @ViewChild('gallerySwiper') gallerySwiperElement!: ElementRef;
  mediaItems: ResourceUrlInterface[] = this.data.items;
  initialIndex: number = this.data.startIndex;
  swiperInstance!: Swiper;
  config: SwiperOptions = {
    initialSlide: this.initialIndex,
    loop: true,
    keyboard: true,
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    spaceBetween: 20,
    slidesPerView: 1,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { items: ResourceUrlInterface[], startIndex: number },
    public dialogRef: MatDialogRef<ResourceGalleryComponent>
  ) {}

  ngAfterViewInit(): void {
    // Wait slightly to ensure MatDialog has fully initialized the DOM dimensions
    if (this.gallerySwiperElement) {
      setTimeout(() => {
        this.swiperInstance = new Swiper(this.gallerySwiperElement.nativeElement, this.config);
        this.swiperInstance.on('slideChangeTransitionEnd', () => this.onSlideChange());
      }, 50);
    }
  }

  // Pauses video when sliding away
  onSlideChange(): void {
    const nonActiveMedia = document.querySelectorAll('.swiper-slide:not(.swiper-slide-active) video, .swiper-slide:not(.swiper-slide-active) iframe');

    nonActiveMedia.forEach((mediaElement) => {
      if ('pause' in mediaElement && typeof (mediaElement as HTMLVideoElement).pause === 'function') {
        (mediaElement as HTMLVideoElement).pause();
      }
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.swiperInstance?.destroy(true, true);
  }
}
